export default [
  {
    header: 'UTILIDADES',
    resource: 'Utilidades',
    action: 'menu',
  },
  {
    title: 'Utilidades',
    route: 'utilidades',
    icon: 'DollarSignIcon',
    action: 'menu',
    resource: 'Utilidades'
  },
  {
    title: 'Mantenimiento U',
    route: 'mantenimientou',
    icon: 'ExternalLinkIcon',
    action: 'menu',
    resource: 'Mantenimiento U'
  },
]
